<template>
  <div class="ticketpurchase">
    <h1 class="ticket-purchase-title">Please choose the type of tickets</h1>
    <ul class="ticket-purchase-list">
      <li
        :class="{
          'currentTicket': ticketpurchase === index,
          'disableTicket': index == 0
          }"
        @click="changeTicketType(index)"
        v-for="(item, index) in currentTypeList"
        :key="item.code">
        <div class="title">{{ item.title }}</div>
        <div class="describe">{{ item.buyTip }}</div>
        <div class="current-logo-box">
          <img src="~@/assets/image/common/common_select.png" alt=""/>
        </div>
      </li>
      <!-- <li class="hide" v-for="index in complement" :key="index"></li> -->
    </ul>
    <div class="handle-ticket-purchase" @click="handleTicketPurchase">
      <button>Buy Ticket</button>
    </div>
    <div class="remind">Children aged 6 or under OR no higher than 1.2 meters,and tourists aged 60 or above can enter the park for free</div>
    <group-notice
    :currentCode="currentCode"
    @closeStateNotice="closeStateNotice"
    :groupStateNotice="groupStateNotice"
    v-if="groupStateNotice">
    </group-notice>
    <yzyPopup title="提示" :message="lpTips" :show="lpShow" @closePopup="close"></yzyPopup>
  </div>
</template>

<script>
import yzyPopup from '@/components/buyTickets/common/yzyPopup'
import groupNotice from "@/components/entry/buyTicketHome/group-notice/index.vue";
export default {
  name: "ticketpurchase",
  data(){
    return {
       lpTips: 'Suzhou Street building protection, joint tickets temporarily suspended from sale',
      lpShow:false,
      touristtype: 0,
      ticketpurchase: 1,
      currentTypeList: [],
      currentCode: null,
      groupStateNotice: false,
    }
  },
  created(){
    this.initialization();
  },
  methods: {
    initialization(){
      this.touristtype = Number(this.$route.params.touristtype);
      this.ticketpurchase = Number(this.$route.params.ticketpurchase);
      if(this.ticketpurchase == 0){
        this.ticketpurchase = 1
      }
      if(this.touristtype === 0){
        this.currentTypeList = this.$store.state.ticketWindow.individualticketlistWindowList;
      } else if(this.touristtype === 1){
        this.currentTypeList = this.$store.state.ticketWindow.passCheckTicketlistWindowList;
      } else if(this.touristtype === 2){
        this.currentTypeList = this.$store.state.ticketWindow.residencePermitTicketlistWindowListEn;
      } else if(this.touristtype === 3){
        this.currentTypeList = this.$store.state.ticketWindow.passportPermitTicketlistWindowListEn;
      } else if(this.touristtype === 4){
        this.currentTypeList = this.$store.state.ticketWindow.groupTicketlistWindowList;
      }
    },
    changeTicketType(index){
       if(index == 0) {
        this.lpShow = true
        return
      }
      this.ticketpurchase = index;
      const path = `/buytickethomeEn/${this.touristtype}/${index}`;
      if(this.$route.path === path)return;
      this.$router.push(path)
    },
    close() {
      this.lpShow = false
    },
    closeStateNotice(){
      this.$beyondHiding(false);
      this.groupStateNotice = false;
    },
    handleTicketPurchase(){
      const item = this.currentTypeList[this.ticketpurchase];
      const { code } = item;
      if(this.touristtype === 0){
        this.$router.push(`/touristfitshoppingcart?ticketcode=${code}`);
      }else if(this.touristtype === 4){
        // this.currentCode = code;
        // this.groupStateNotice = true;
        // this.$beyondHiding(true);
        this.$router.push(`/touristguideshoppingcart?ticketcode=${code}`);
      }else{
        this.$router.push(`/touristhmtshoppingcartEn?ticketcode=${code}`);
      };
    },
  },
  watch: {
    '$route'(route){
      this.initialization();
    }
  },
  components: {
    'group-notice': groupNotice,
    yzyPopup
  },
};
</script>

<style scoped lang='less'>
.ticket-purchase-title{
  margin: .4rem 0 .266667rem;
  font-size: .4rem;
  font-weight: bold;
  color: #333333;
  line-height: .56rem;
};
.ticket-purchase-list{
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap; /* 允许多行 */
   & > li:nth-child(1){
    width: 4.2rem
  }
   & > li:nth-child(2){
    width: 4.2rem
  }
  & > li:nth-child(3){
    width: 100%
  }
  & > li{
    background: #FFFFFF;
    box-shadow: 0 .053333rem .106667rem .026667rem rgba(193, 60, 48, 0.04);
    border-radius: .186667rem;
    border: 1px solid #F5F5F5;
    width: 4.2rem;
    padding: .186667rem 0 .226667rem;
    text-align: center;
    margin-bottom: .266667rem;
    height: 1.6rem;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    .title{
      font-size: .4rem;
      line-height: .56rem;
    }
    .describe{
      font-size: .32rem;
      line-height: .44rem;
      margin-top: .08rem;
    }
    .current-logo-box{
      display: none;
    }
  };
   .disableTicket{
    background: rgb(163, 161, 161);
    // border: 2px solid #9D6C29 !important;
    color: #000 !important;
    position: relative;
  }
  .currentTicket{
    background: rgba(237, 192, 132, 0.35);
    border: 2px solid #9D6C29 !important;
    color: #9D6C29 !important;
    position: relative;
    .current-logo-box{
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: -0.026667rem;
      width: 0.346667rem;
      height: 0.346667rem;
      bottom: -0.026667rem;
      border: 2px solid #9D6C29;
      border-radius: .066667rem .066667rem .16rem .066667rem;
      img{
        width: 0.346667rem;
        height: 0.346667rem;
      }
    }
  }
  .hide{
    visibility: hidden;
  }

  .currentDomestic{
    &:nth-child(2){
      margin: 0 .266667rem;
      white-space: nowrap;
    }
  }
}
.handle-ticket-purchase{
  padding: .533333rem .2rem 0;
  position: relative;
  button{
    display: block;
    background: #9D6C29;
    border-radius: .573333rem;
    font-size: .48rem;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 1.146667rem;
    width: 100%;
  }
}
.remind{
  margin-top: .133333rem;
  text-align: center;
  font-size: .32rem;
  color: #999999;
  line-height: .44rem;
  padding: 0 .6667rem;
}
</style>
